import { useTranslations } from 'next-intl'

import { cn } from '@/shared/lib'
import { ContentBox, Icon } from '@/shared/ui'

import {
  DuplexStructureMessageProps,
  SharedPlaceMessageProps,
  StructureProps,
} from './index.pc'
import { Heading, Item, Label, List, Value } from '../../common'

export const MobileStructure = ({
  roomCnt,
  bathroomCnt,
  sittingroomCnt,
  cookroomCnt,
  sharedRoom,
  sharedBathroom,
  sharedCookroom,
  className,
}: StructureProps & { className?: string }) => {
  const t = useTranslations()

  return (
    <div className={cn('space-y-4', className)}>
      <Heading size="small">{t('room_detail.layout.title')}</Heading>
      <List spacing="small" className="typo-body2 text-gray-900">
        <Item className="justify-between">
          <Label icon="room" className="font-semibold">
            {t('common.bedroom')}
          </Label>
          <Value>
            {sharedRoom
              ? t('room_detail.layout.type.shared_room')
              : t('room_detail.layout.count', { number: roomCnt })}
          </Value>
        </Item>
        <Item className="justify-between">
          <Label icon="restroom" className="font-semibold">
            {t('common.bathroom')}
          </Label>
          <Value>
            {sharedBathroom
              ? t('room_detail.layout.type.shared')
              : t('room_detail.layout.count', { number: bathroomCnt })}
          </Value>
        </Item>
        <Item className="justify-between">
          <Label icon="kitchen" className="font-semibold">
            {t('common.kitchen')}
          </Label>
          <Value>
            {sharedCookroom
              ? t('room_detail.layout.type.shared')
              : t('room_detail.layout.count', { number: cookroomCnt })}
          </Value>
        </Item>
        <Item className="justify-between">
          <Label icon="livingRoom" className="font-semibold">
            {t('common.living_room')}
          </Label>
          <Value>
            {sharedCookroom
              ? t('room_detail.layout.type.shared')
              : t('room_detail.layout.count', { number: sittingroomCnt })}
          </Value>
        </Item>
      </List>
    </div>
  )
}

export const MobileSharedPlaceMessage = ({
  sharedRoom,
  sharedBathroom,
  sharedCookroom,
  className,
}: SharedPlaceMessageProps & { className?: string }) => {
  const t = useTranslations('room_detail.layout.shared')

  if (!sharedRoom && !sharedBathroom && !sharedCookroom) {
    return null
  }

  return (
    <div className={cn('flex items-center', className)}>
      <Icon name="alert-filled" className="text-red-500" size={24} />
      <p className="typo-label1 font-medium text-red-500">
        {(() => {
          if (sharedRoom && sharedBathroom && sharedCookroom) {
            return t('all_structure')
          }

          if (sharedRoom && sharedBathroom) {
            return t('room_bathroom')
          }

          if (sharedRoom && sharedCookroom) {
            return t('room_kitchen')
          }

          if (sharedBathroom && sharedCookroom) {
            return t('bathroom_kitchen')
          }

          if (sharedRoom) {
            return t('room')
          }

          if (sharedBathroom) {
            return t('bathroom')
          }

          if (sharedCookroom) {
            return t('kitchen')
          }

          return ''
        })()}
      </p>
    </div>
  )
}

export const MobileDuplexStructureMessage = ({
  duplexStructure,
  className,
}: DuplexStructureMessageProps & { className?: string }) => {
  const t = useTranslations('room_detail.layout')

  if (!duplexStructure) {
    return null
  }

  return (
    <ContentBox spacing="medium" color="purple" className={className}>
      <p className="typo-label2 font-normal text-gray-900">
        {t.rich('loft', {
          strong: chunks => (
            <strong className="typo-label1 font-semibold text-black">
              {chunks}
            </strong>
          ),
        })}
      </p>
    </ContentBox>
  )
}
